"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataGrid = DataGrid;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _dxReactGrid = require("@devexpress/dx-react-grid");
var _dxReactGridMaterialUi = require("@devexpress/dx-react-grid-material-ui");
var _components = require("../components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var StyledTableFixedColumnsCell = (0, _material.styled)(_dxReactGridMaterialUi.TableFixedColumns.Cell)(function (_ref) {
  var theme = _ref.theme;
  var value = theme.palette.mode === 'dark' ? '#29404e' : '#eaf3f8';
  return {
    '&.TableFixedCell-selected': {
      backgroundColor: value
    },
    '&.TableFixedCell-selected:hover': {
      backgroundColor: value
    }
  };
});
function DataGrid(_ref2) {
  var sourceGetId = _ref2.getId,
    sourceItems = _ref2.items,
    sourceColumns = _ref2.columns,
    selectable = _ref2.selectable,
    clickable = _ref2.clickable,
    refreshable = _ref2.refreshable,
    _ref2$hoverable = _ref2.hoverable,
    hoverable = _ref2$hoverable === void 0 ? false : _ref2$hoverable,
    empty = _ref2.empty,
    error = _ref2.error,
    loading = _ref2.loading;
  var isSelectable = !!selectable;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    columns = _useState4[0],
    setColumns = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    columnExtensions = _useState6[0],
    setColumnExtensions = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    leftColumns = _useState8[0],
    setLeftColumns = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState9, 2),
    rightColumns = _useState10[0],
    setFixedColumns = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    selection = _useState12[0],
    setSelection = _useState12[1];
  (0, _react.useEffect)(function () {
    setItems(sourceItems.map(function (item, index) {
      return {
        item: item,
        index: index
      };
    }));
  }, [sourceItems]);
  (0, _react.useEffect)(function () {
    var cols = sourceColumns.map(function (col, indexCol) {
      var title;
      if (refreshable && refreshable.columnId === col.id) {
        title = /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
          size: "small",
          onClick: refreshable.onClick
        }, /*#__PURE__*/_react["default"].createElement(_components.RefreshIcon, null));
      } else {
        title = col.title;
      }
      return {
        name: col.id,
        title: title,
        getCellValue: function getCellValue(row, columnName) {
          var item = row.item,
            index = row.index;
          var content = col.converter(item, indexCol, index);
          var disabled = (clickable === null || clickable === void 0 ? void 0 : clickable.disabled) ? clickable.disabled(item) : false;
          if (indexCol === 0 && !!(clickable === null || clickable === void 0 ? void 0 : clickable.onClick)) {
            return /*#__PURE__*/_react["default"].createElement(_material.Button, {
              size: "medium",
              color: "primary",
              variant: "text",
              disabled: disabled,
              onClick: function onClick() {
                return clickable.onClick(item, index);
              },
              sx: {
                px: 0.5,
                py: 0.5,
                minWidth: 30
              }
            }, content);
          }
          return content;
        }
      };
    });
    var leftCols = sourceColumns.filter(function (col) {
      return col.fixed === 'left';
    }).map(function (col) {
      return col.id;
    });
    if (isSelectable) {
      leftCols = [_dxReactGridMaterialUi.TableSelection.COLUMN_TYPE].concat(_toConsumableArray(leftCols));
    }
    var rightCols = sourceColumns.filter(function (col) {
      return col.fixed === 'right';
    }).map(function (col) {
      return col.id;
    });
    var colExtensions = sourceColumns.map(function (col) {
      return {
        columnName: col.id,
        width: col.width,
        align: col.textAlign,
        wordWrapEnabled: col.wordWrapEnabled
      };
    });
    setColumns(cols);
    setLeftColumns(leftCols);
    setFixedColumns(rightCols);
    setColumnExtensions(colExtensions);
  }, [sourceColumns, isSelectable, clickable, refreshable]);
  (0, _react.useEffect)(function () {
    var _a;
    setSelection((_a = selectable === null || selectable === void 0 ? void 0 : selectable.selected) !== null && _a !== void 0 ? _a : []);
  }, [selectable === null || selectable === void 0 ? void 0 : selectable.selected]);
  var getId = (0, _react.useCallback)(function (item) {
    return sourceGetId(item.item, item.index);
  }, [sourceGetId]);
  var onSelectionChange = function onSelectionChange(selectedIds) {
    if (isSelectable) {
      var ids = selectedIds.map(function (id) {
        return "".concat(id);
      });
      var selectedItems = items.filter(function (indexItem) {
        var id = getId(indexItem);
        return ids.indexOf(id) >= 0;
      }).map(function (item) {
        return item.item;
      });
      selectable.onChange(ids, selectedItems);
      setSelection(ids);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_dxReactGrid.Grid, {
    rows: items,
    columns: columns,
    getRowId: getId,
    rootComponent: _dxReactGridMaterialUi.Grid.Root
  }, selectable && (/*#__PURE__*/_react["default"].createElement(_dxReactGrid.SelectionState, {
    selection: selection,
    onSelectionChange: onSelectionChange
  })), selectable && /*#__PURE__*/_react["default"].createElement(_dxReactGrid.IntegratedSelection, null), /*#__PURE__*/_react["default"].createElement(_dxReactGridMaterialUi.Table, {
    columnExtensions: columnExtensions,
    messages: {
      noData: empty
    },
    tableComponent: TableComponent,
    rowComponent: RowComponent(hoverable),
    noDataRowComponent: NoDataRowComponent,
    noDataCellComponent: NoDataCell(loading, error),
    headComponent: HeadComponent
  }), /*#__PURE__*/_react["default"].createElement(_dxReactGridMaterialUi.TableHeaderRow, null), selectable && (/*#__PURE__*/_react["default"].createElement(_dxReactGridMaterialUi.TableSelection, {
    showSelectAll: true,
    highlightRow: true,
    rowComponent: RowComponent(hoverable),
    showSelectionColumn: true,
    cellComponent: SelectionCell(false, selectable.disabled),
    headerCellComponent: SelectionCell(true, selectable.disabled)
  })), (leftColumns.length > 0 || rightColumns.length > 0) && (/*#__PURE__*/_react["default"].createElement(_dxReactGridMaterialUi.TableFixedColumns, {
    leftColumns: leftColumns,
    rightColumns: rightColumns,
    cellComponent: function cellComponent(props) {
      return /*#__PURE__*/_react["default"].createElement(StyledTableFixedColumnsCell, Object.assign({}, props));
    }
  })));
}
var TableComponent = function TableComponent(props) {
  var forwardedRef = props.forwardedRef,
    children = props.children,
    style = props.style;
  return /*#__PURE__*/_react["default"].createElement(_material.Table, {
    ref: forwardedRef,
    size: "small",
    padding: "normal",
    style: style
  }, children);
};
var HeadComponent = function HeadComponent(props) {
  var forwardedRef = props.forwardedRef,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_material.TableHead, {
    ref: forwardedRef,
    sx: function sx(theme) {
      var color = theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.grey[100];
      return {
        bgcolor: color,
        '& .MuiTableCell-head': {
          bgcolor: "".concat(color, " !important")
        }
      };
    }
  }, children);
};
var RowComponent = function RowComponent(hoverable) {
  return function (_ref3) {
    var forwardedRef = _ref3.forwardedRef,
      children = _ref3.children,
      style = _ref3.style,
      highlighted = _ref3.highlighted;
    return /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
      ref: forwardedRef,
      style: style,
      hover: hoverable,
      selected: highlighted
    }, children);
  };
};
var NoDataRowComponent = function NoDataRowComponent(props) {
  var forwardedRef = props.forwardedRef,
    children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
    ref: forwardedRef,
    sx: function sx(theme) {
      return {
        height: theme.spacing(6)
      };
    }
  }, children);
};
var NoDataCell = function NoDataCell(loading, error) {
  return function (cellProps) {
    return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
      colSpan: cellProps.colSpan,
      rowSpan: cellProps.rowSpan,
      align: "center"
    }, error && /*#__PURE__*/_react["default"].createElement(_components.ErrorTypography, {
      text: error
    }), loading && /*#__PURE__*/_react["default"].createElement(_components.Progress, {
      size: "1.5rem"
    }), !(error || loading) && cellProps.getMessage('noData'));
  };
};
var SelectionCell = function SelectionCell(header, notAvailable) {
  return function (cellProps) {
    var _a, _b;
    var checked,
      indeterminate,
      disabled = undefined;
    if (header) {
      checked = cellProps.allSelected;
      indeterminate = cellProps.someSelected;
      disabled = notAvailable && notAvailable.length > 0;
    } else {
      var id = (_b = (_a = cellProps.row) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.id;
      checked = cellProps.selected;
      disabled = cellProps.disabled || (notAvailable === null || notAvailable === void 0 ? void 0 : notAvailable.find(function (el) {
        return el === id;
      })) !== undefined;
    }
    return /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
      variant: header ? 'head' : 'body',
      padding: "none",
      colSpan: cellProps.colSpan,
      rowSpan: cellProps.rowSpan,
      className: cellProps.className,
      style: cellProps.style
    }, /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      size: "medium",
      checked: checked,
      indeterminate: indeterminate,
      disabled: disabled,
      onChange: function onChange() {
        return cellProps.onToggle();
      }
    }));
  };
};